import { StaticBaseDao } from '@/dao';
import { StationAlias } from '@/objects/generated';

export class StationAliasDao extends StaticBaseDao {
    public static async ReplayTimesForAlias(aliases: StationAlias[], EventID: number): Promise<boolean | null> {
        return this.Post(`StationAlias/ReplayTimesForAlias` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), aliases);
    }
}
